module.exports = __webpack_public_path__ + "img/Youtube.61787bcd.png";